import React, { useMemo } from 'react';
import {
  Button,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';
import CreatePackageButton from 'pages/quotes/QuoteItems/CreatePackageButton';
import QuoteListingsSummary from './EditQuoteListingsSummary';


const EditQuoteListingsFooter = ({
  formik,
  calculatedTotals,
  handleAddMoreItem,
  loading
}) => {
  const {
    values,
    isValid,
    dirty
  } = formik;

  const {subTotal, discount, total} = calculatedTotals;

  const packageItems = useMemo(() => {
    return (items) => {
      if (!items.length) {
        return [];
      }

      const selectedItems = items.map((item) => {
        const { sku, discountType, discount, qty, subscription_id, fixedPrice, custom_subscription_price } = item;

        return {
          sku,
          qty,
          product_option: {
            extension_attributes: {
              quotepro_discounts: {
                price_type: discountType,
                price: discount,
              },
              subscription_id
            },
          },
          price: fixedPrice,
          custom_subscription_price
        };
      });

      return selectedItems;
    };
  }, []);

  const isDisabledButtonAction = loading || !(isValid && dirty);

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={6}>
        <div className="flex items-center">
          <Typography variant="h6" className="mr-3">
            {values.items.length && values.items[0].sku ? values.items.length : 0}
            {` Item${values.items.length > 1 ? 's' : ''}`}
          </Typography>
          <CreatePackageButton
            packageItems={packageItems(values.items)}
            totalPrice={total}
            isDisabled={isDisabledButtonAction}
          />
        </div>
      </Grid>
      <Grid item xs={6} container justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          disabled={isDisabledButtonAction}
          onClick={handleAddMoreItem}
        >
          + Add More Item
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Grid container justifyContent="flex-end">
          <QuoteListingsSummary
            discount={discount}
            subTotal={subTotal}
            total={total}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditQuoteListingsFooter;
